<div class="container">
    <h2>We have your valid id use this or Upload new one</h2>
    
    <div class="camera-preview">
      <!-- Placeholder for the selfie preview -->
      <div class="snapshot" *ngIf="appservice.Proof_Image"><img  [src]="appservice.Proof_Image" /></div>
      <img *ngIf="!appservice.Proof_Image" class="image" [height]="150" [width]="200"
        src="{{appservice.Server_URL}}/image/Proof{{appservice.Company_}}/Proof{{Contact_No}}.png" 
        (error)="img.src = '../../assets/img/user9.jpg'" #img />
      
    </div>
  
    <div class="buttons">
      <button (click)="take_photo()" class="camera-btn">
        <i class="mdi mdi-camera"></i>
      </button>
    </div>
  
    <div class="action-buttons">
      <button (click)="appservice.back()">Back</button>
      <button [disabled]="btndisable" (click)="addData()">submit</button>
    </div>
  
  </div>
  